import React, {Component} from "react";
import axios from "axios/index";
import DualListBox from 'react-dual-listbox';
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
//import {css} from "emotion";
import { css } from "@emotion/core";
import {BeatLoader} from "react-spinners";

//https://github.com/jakezatecky/react-dual-listbox
//https://github.com/jakezatecky/react-dual-listbox/issues/41

const override = css`
    position: absolute;
    left: 47%;
    top: 30%;
    display: block;
    z-index: 1000;
    `;


class DualListBoxPackageLive extends Component {

    constructor(props) {
        super(props);

        this.handleChannelSelect = this.handleChannelSelect.bind(this);

        this.state = {
            loading: false,

            availableChannels: [],
            selectedArray: []
        };
        this.onChange = this.onChange.bind(this);

    }

    handleChannelSelect(selected) {
        this.props.handlerFromParent(selected);
    }

    onChange(selected) {

        this.setState({selectedArray: selected});
        this.handleChannelSelect(selected)
    }

    componentDidMount() {
        this.timeout = setTimeout(() => {
            this.loadAvailableChannelsFromMiddleware();
        }, 500); // delay 500ms
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.dma !== prevProps.dma) {
            this.loadAvailableChannelsFromMiddleware();
            console.log(this.props.dma)
        }
    }

    loadAvailableChannelsFromMiddleware() {

        let url = process.env.REACT_APP_API_URL + "/LivePackage/channels";

        if (this.props.dma && Array.isArray(this.props.dma) && this.props.dma.length > 0) {
            url =
                process.env.REACT_APP_API_URL +
                "/LivePackage/channels?forDma=" +
                this.props.dma.join(",");
        }

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {'X-Id-Token': token}
        };


        axios
            .get(url, axiosConfig)
            .then(res => {

                let temp = res.data;

                let availableChannels = [];
                let obj = {};

                for (let i = 0; i < temp.length; i++) {
                    //console.log(temp[i].value.toString())

                    obj = {
                        value: temp[i].value.toString(),
                        label: temp[i].label

                    }
                    availableChannels.push(obj)
                }

                // filter current selected values so they exist in availableChannels
                const availableSet = new Set(availableChannels.map((o) => o.value));
                const currentSelected = (this.props.channelsInPackage || []).map(String);

                const filteredSelected = currentSelected.filter((v) =>
                    availableSet.has(v)
                );

                // notify parent if selection changed
                if (filteredSelected.length !== currentSelected.length) {
                    this.handleChannelSelect(filteredSelected);
                }

                this.setState({ availableChannels, loading: false });
            })
            .catch(error => {
                console.log(error);
                this.props.dispatch(userActions.logoutUnauthorized());
            });

    }

    render() {
        return (
            <div>

                <div className="sweet-loader">
                    <BeatLoader
                        css={override}
                        size={5}
                        color={'#2c67a4'}
                        loading={this.state.loading}
                        //loading={true}
                    />
                </div>

                <DualListBox
                    options={this.state.availableChannels}
                    canFilter
                    availableLabel={"Available"}
                    selectedLabel={"Selected"}
                    showHeaderLabels
                    simpleValue={true}
                    selected={this.props.channelsInPackage}
                    onChange={this.onChange}
                />
            </div>
        );
    }
}


function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDualListBoxPackageLive = connect(mapStateToProps)(DualListBoxPackageLive);
const connectedDualListBoxPackageLiveTrans = withNamespaces('common')(connectedDualListBoxPackageLive);
export {connectedDualListBoxPackageLiveTrans as DualListBoxPackageLive};
